export const HANDLE_PUBLICATION_REQUEST = 'HANDLE_PUBLICATION_REQUEST';
export const SET_FILTERS = 'SET_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_ORGANISAIONS = 'SET_ORGANISAIONS';
export const SET_PUBLICATIONS = 'SET_PUBLICATIONS';
